import { render, staticRenderFns } from "./Merchantlist.vue?vue&type=template&id=a50fe322&scoped=true"
import script from "./Merchantlist.vue?vue&type=script&lang=js"
export * from "./Merchantlist.vue?vue&type=script&lang=js"
import style0 from "./Merchantlist.vue?vue&type=style&index=0&id=a50fe322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50fe322",
  null
  
)

export default component.exports